const Backbone = window.Backbone;

const TitleDescription = Backbone.View.extend({
    initialize() {
        this.render();
    },

    template() {
        return `
            ${this._description()}
            ${this._readMoreLink()}
        `;
    },

    _readMoreLink() {
        if (this.model.get('description').length) {
            return `
                <a href="${
                    this.model.titleDetailsUrl
                }" class="expand-description contrast">
                        ${window.html('cover.readMore')}
                </a>
            `;
        }

        return '';
    },

    _description() {
        if (this.model.get('description').length) {
            return this.model.sanitizedDesc();
        }

        return window.html('titleDetails.noDescAvailable');
    },

    render() {
        this.$el.html(this.template());
    },
});

module.exports = TitleDescription;
